import { Button } from "@components/atoms/Button"
import { Themed } from "@components/atoms/Themed"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { useAppData } from "eddev/hooks"
import { Link, useRoute } from "eddev/routing"
import { usePageContext } from "../../contexts/PageContext"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"

export const meta: BlockMeta = {
  title: "Site Footer",
  lazyLoad: false,
}

export default defineBlock("parts/part-footer", (props) => {
  const footerMenu = useAppData((data) => data.footerMenu?.menuItems?.nodes)
  const socialMenu = useAppData((data) => data.socialMenu?.menuItems?.nodes)
  const { theme, footerTheme } = usePageContext()
  const th = footerTheme && footerTheme !== "none" ? footerTheme : theme
  const actualTheme = !!th && th !== "none" ? th : "navy"
  const route = useRoute()
  const isHome = route.pathname === "/"
  const edges = true //route.pathname !== "/"

  return (
    <Themed className="w-full" theme={actualTheme}>
      <div className={cn("py-grid-margin", edges && "themed-bg themed-fg")}>
        <div className="w-full max-w-cols-12 mx-auto">
          {edges && !isHome && (
            <div className={cn("w-full flex")}>
              <div className="w-full grid grid-cols-1 md:grid-cols-2">
                <div className="w-full aspect-video rounded-xl overflow-hidden">
                  {env.admin && !props.image?.mediaItemUrl && !props.video?.mediaItemUrl && (
                    <div className="w-full aspect-video bg-grey flex items-center justify-center type-ui">
                      Select media
                    </div>
                  )}
                  {props.image && !props.video && <ResponsiveImage {...props.image} className="w-full h-auto" />}
                  {!props.image && props.video?.mediaItemUrl && (
                    <video src={props.video.mediaItemUrl} className="w-full h-auto" playsInline autoPlay muted loop />
                  )}
                </div>
                <div className="w-full p-7 self-stretch flex flex-col justify-center items-start gap-5 rounded-xl text-black bg-white">
                  <EditableText
                    as="h2"
                    store="title"
                    className="type-title-m text-balance md:w-11/12"
                    defaultValue="Enter a title"
                  />
                  <Themed theme={"white"} className="flex items-center flex-wrap gap-2 md:gap-2 mt-5 md:mt-0">
                    <InnerBlocks
                      allowedBlocks={["content/button"]}
                      template={[["content/button", {}]]}
                      orientation="horizontal"
                      adminClassName="flex items-center gap-5"
                    />
                  </Themed>
                </div>
              </div>
            </div>
          )}

          <div
            className={cn(
              "w-full flex flex-col md:flex-row md:justify-between themed-bg themed-fg rounded-lg p-7 gap-7 md:gap-0",
              edges && "border-2 border-current",
            )}
          >
            <div className="w-full flex flex-col md:w-2/3 justify-between self-stretch gap-10 md:gap-5">
              <div className="w-full">
                {/* <EditableText
                  store="newsletterText"
                  as="p"
                  className="type-label-s-caps block mb-4"
                  placeholder="Newsletter"
                  defaultValue="Newsletter"
                />
                <EditableText
                  store="newsletterDescription"
                  as="p"
                  className="type-title-s md:type-title-m"
                  placeholder="Outcomes, not just outputs."
                  defaultValue="Outcomes, not just outputs."
                />
                <form
                  action={""}
                  method="post"
                  id="mc-embedded-subscribe-form"
                  name="mc-embedded-subscribe-form"
                  target="_blank"
                  className="flex flex-col gap-4 w-full"
                >
                  <input
                    type="email"
                    name="EMAIL"
                    className="flex w-fit outline-none type-title-s md:type-title-m appearance-none bg-transparent border-none text-current placeholder:text-current placeholder:opacity-50"
                    id="mce-EMAIL"
                    required
                    placeholder="Email address"
                  />
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      name="terms"
                      id="terms"
                      className="block w-[0.8em] h-[0.8em] border border-current rounded-[0.2em] appearance-none bg-transparent checked:bg-current transition-colors duration-300 cursor-pointer"
                    />
                    <label htmlFor="terms" className="type-label-s-caps cursor-pointer">
                      Accept terms
                    </label>
                  </div>
                  <Button type="submit">Subscribe</Button>
                </form> */}

                <div className="flex flex-col gap-4 w-full max-w-[30em]">
                  <EditableText
                    store="footTextTitle"
                    as="p"
                    className="type-title-s md:type-title-m"
                    placeholder="Ready to make the right workplace decision?"
                    defaultValue="Ready to make the right workplace decision?"
                  />
                  <EditableText
                    store="footTextBody"
                    as="p"
                    className="type-body-m text-balance"
                    placeholder="Whether you’re approaching lease expiry, planning for growth, or rethinking how your people work, let’s have a conversation grounded in insight."
                    defaultValue="Whether you’re approaching lease expiry, planning for growth, or rethinking how your people work, let’s have a conversation grounded in insight."
                  />
                  <div className="flex flex-col gap-2 mt-4">
                    {props.button1?.url && (
                      <Button href={props.button1.url} target={props.button1.target || undefined}>
                        {props.button1.title}
                      </Button>
                    )}
                    {props.button2?.url && (
                      <Button href={props.button2.url} target={props.button2.target || undefined}>
                        {props.button2.title}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <svg
                className="w-footerLogoW h-footerLogoH"
                viewBox="0 0 416 84"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M233.102 11.1643H220.27V26.3078H209.324V38.4328H220.27V69.6651C220.27 76.8252 226.074 82.6285 233.234 82.6285H247.91V70.3714H233.102V38.5598H247.91V26.3027H233.102V11.1592V11.1643Z"
                  fill="currentColor"
                />
                <path
                  d="M40.6944 70.8184C25.434 70.8184 13.8731 58.4494 13.8731 42.2641C13.8731 26.0789 25.434 13.9386 40.6944 13.9386C51.4474 13.9386 60.6961 20.2959 63.237 29.4277H78.2636C75.6059 12.7851 59.1919 0.761719 40.6944 0.761719C17.5726 0.761719 0 18.6799 0 42.2641C0 65.8484 17.5726 84.0003 40.6944 84.0003C59.7712 84.0003 75.2603 71.8601 78.4974 54.2875H63.3538C60.9248 64.1156 51.676 70.8184 40.6944 70.8184Z"
                  fill="currentColor"
                />
                <path
                  d="M113.848 25.1533C97.2 25.1533 84.4805 37.8678 84.4805 54.6324C84.4805 71.397 97.2 83.9997 113.848 83.9997C130.495 83.9997 143.093 71.2801 143.093 54.6324C143.093 37.9847 130.262 25.1533 113.848 25.1533ZM113.848 71.6257C104.365 71.6257 96.9663 64.2267 96.9663 54.6324C96.9663 45.0381 104.365 37.4054 113.848 37.4054C123.33 37.4054 130.607 44.9212 130.607 54.6324C130.607 64.3436 123.096 71.6257 113.848 71.6257Z"
                  fill="currentColor"
                />
                <path
                  d="M177.57 25.1533C161.964 25.1533 151.094 36.2518 151.094 52.4371V82.841H164.042V52.4371C164.042 43.3052 169.357 37.5222 177.57 37.5222C185.782 37.5222 191.097 43.3052 191.097 52.4371V82.841H203.928V52.4371C203.928 36.2518 193.176 25.1533 177.57 25.1533Z"
                  fill="currentColor"
                />
                <path
                  d="M283.078 25.1533C266.43 25.1533 253.711 37.8678 253.711 54.6324C253.711 71.397 266.43 83.9997 283.078 83.9997C299.726 83.9997 312.324 71.2801 312.324 54.6324C312.324 37.9847 299.492 25.1533 283.078 25.1533ZM283.078 71.6257C273.596 71.6257 266.197 64.2267 266.197 54.6324C266.197 45.0381 273.596 37.4054 283.078 37.4054C292.561 37.4054 299.838 44.9212 299.838 54.6324C299.838 64.3436 292.327 71.6257 283.078 71.6257Z"
                  fill="currentColor"
                />
                <path
                  d="M360.574 56.7164C360.574 65.8483 355.141 71.6313 347.046 71.6313C338.951 71.6313 333.519 65.8483 333.519 56.7164V26.3125H320.57V56.7164C320.57 72.9017 331.435 84.0002 347.046 84.0002C362.657 84.0002 373.405 72.9017 373.405 56.7164V26.3125H360.574V56.7164Z"
                  fill="currentColor"
                />
                <path
                  d="M394.809 26.3125C388.634 26.3125 383.629 31.318 383.629 37.4923V82.8416H396.46V38.5696H415.999V26.3176H394.809V26.3125Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="w-full md:w-1/3 shrink-0 flex flex-col gap-5 md:gap-10 self-stretch">
              <div className="w-full flex flex-col gap-6">
                <div className="w-full flex flex-col gap-1">
                  {footerMenu?.map((item) => (
                    <Link
                      key={item.databaseId}
                      href={item.uri}
                      target={item.target}
                      className={cn("type-ui underline-link")}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
                <div className="w-full flex flex-col gap-1">
                  {socialMenu?.map((item) => (
                    <Link
                      key={item.databaseId}
                      href={item.uri}
                      target={item.target}
                      className={cn("type-ui underline-link")}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
              <div className="w-full flex flex-col gap-1">
                <Link href="tel:1300200750" className="type-ui underline-link">
                  <EditableText store="phone" as="span" placeholder="1300 200 750" defaultValue="1300 200 750" />
                </Link>
                <Link href="mailto:info@contourinteriors.com.au" className="type-ui underline-link">
                  <EditableText
                    store="email"
                    as="span"
                    className="type-ui underline-link"
                    placeholder="info@contourinteriors.com.au"
                    defaultValue="info@contourinteriors.com.au"
                  />
                </Link>
              </div>
              <div className="flex flex-col gap-7">
                <EditableText
                  store="acknowledgment"
                  as="p"
                  className="type-body-s md:w-3/4"
                  placeholder="Contour Interiors acknowledges the Traditional Owners of Country throughout Australia and acknowledges their continuing connection to land, waters and community. We pay our respects to the people, the cultures and the Elders past and present."
                  defaultValue="Contour Interiors acknowledges the Traditional Owners of Country throughout Australia and acknowledges their continuing connection to land, waters and community. We pay our respects to the people, the cultures and the Elders past and present."
                />
                <div className="flex flex-col gap-1">
                  <p>
                    <span className="type-label-s-caps">© {new Date().getFullYear()} </span>
                    <EditableText
                      store="copyright"
                      as="span"
                      className="type-label-s-caps"
                      placeholder="Contour Commercial Interiors"
                      defaultValue="Contour Commercial Interiors"
                    />
                  </p>
                  <div className="flex items-center gap-5 type-label-s-caps">
                    <p>
                      SEO Services by{" "}
                      <Link
                        href="https://www.seoaustralia.net/"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="underline-link"
                      >
                        SEO Australia
                      </Link>
                    </p>
                    <p>
                      <Link href="https://ed.studio" target="_blank" className="underline-link">
                        Site by ED.
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Themed>
  )
})
